import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    lifetime: Number
  }

  #timeout

  connect() {
    if (this.lifetimeValue !== 0) {
      this.#timeout = setTimeout(() => this.element.remove(), this.lifetimeValue)
    }
  }

  disconnect() {
    if (this.#timeout === null) {
      return
    }

    clearTimeout(this.#timeout)
    this.#timeout = null
  }

  close(event) {
    event.preventDefault()
    this.element.remove()
  }
}
